import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  MdHome,
  MdInfo,
  MdStorefront,
  MdContactPhone,
} from 'react-icons/md';
import './BottomNav.css';

const NAV_ITEMS = [
  { id: 'home', label: 'Home', icon: MdHome, path: '/' },
  { id: 'about', label: 'About', icon: MdInfo, path: '/about' },
  { id: 'shop', label: 'Shop', icon: MdStorefront, path: '/shop' },
  { id: 'contact', label: 'Contact', icon: MdContactPhone, path: '/contact' },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeId, setActiveId] = useState('home');
  const navRef = useRef(null);

  // ── Sync active tab with current route ─────────────────
  useEffect(() => {
    const p = location.pathname;
    if (p === '/' || p === '') setActiveId('home');
    else if (p.startsWith('/about')) setActiveId('about');
    else if (p.startsWith('/shop')) setActiveId('shop');
    else if (p.startsWith('/contact')) setActiveId('contact');
    else setActiveId('');
  }, [location.pathname]);

  // ── Navigation handler ─────────────────────────────────
  const handleNav = (item) => {
    setActiveId(item.id);
    navigate(item.path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* ── Bottom Dock ── */}
      <nav ref={navRef} className="bn-dock" role="navigation" aria-label="Mobile Navigation">
        <div className="bn-dock-inner">
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            const isActive = activeId === item.id;

            return (
              <button
                key={item.id}
                className={`bn-item ${isActive ? 'active' : ''}`}
                onClick={() => handleNav(item)}
                aria-label={item.label}
              >
                <div className="bn-icon-wrap">
                  {isActive && <span className="bn-glow" />}
                  <Icon size={24} className="bn-icon" />
                </div>
                <span className="bn-label">{item.label}</span>
                {isActive && <span className="bn-active-dot" />}
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
}
